export default "__VITE_ASSET__CjODidlj__"